import React from 'react'
import { useAviso } from '../Context'
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export default function Aviso() {
    const { aviso, setAviso } = useAviso();
    const { open, message, severity } = aviso;

    const handleClose = () => {
        setAviso({ ...aviso, open: false })
    }
    
    return(
        <Snackbar
        open={open}
        autoHideDuration={30000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} variant="filled" severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    )
}